import React, { useState } from "react";
import {  AiOutlineInfoCircle } from 'react-icons/ai';
import { useModal } from "../../../../../../../../src/contexts/customModal";
import { fetchAllPromisedData } from "../../../../../../../../src/views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "../../../../../../../../src/views/pages/manage/common/constant";
import { failureToast } from "../../../../../../../../src/views/pages/manage/common/utils/methods/toasterFunctions/function";

const approvalData = [
  { level: "L1 Approval", key: "l1Quota" },
  { level: "L2 Approval", key: "l2Quota" },
  { level: "L3 Approval", key: "l3Quota" },
];

const ApprovalList = ({ data }) => (
  <div style={styles.container}>
    {approvalData.map((item, index) => (
      <div key={index} style={styles.row}>
        <span>{item.level}</span>
        <span>{data?.[item.key] || 0}%</span>
      </div>
    ))}
  </div>
);

const styles = {
  container: {
    width: "400px",
    margin: "20px",
    marginTop: "0px",
    fontFamily: "Arial, sans-serif",
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    padding: "8px 0",
    fontSize: "16px",
    color: "#000000",
  },
};

const ViewApprovalPercentageBreakdown = ({
  row,
  classNameList = "mb-3 ml-2",
  useApi = false,
}) => {
  const { showModal } = useModal();
  const [loading, setLoading] = useState(false);

  const handleOpenModal = async () => {
    if (!useApi) {
      return showModal({
        title: "Approval Percentages",
        content: <ApprovalList data={row} />,
      });
    }

    const { applicationId, applicationQuotationDetailsId } = row || {};
    if (!applicationId || !applicationQuotationDetailsId) {
      return failureToast("Missing required IDs for API call.");
    }

    setLoading(true);
    try {
      const url = `${endpoint.studentChargesConcessionDetailsConcession.getByApplicationId}/${applicationId}?applicationQuotationDetailId=${applicationQuotationDetailsId}`;
      const response = await fetchAllPromisedData(url);

      const latestCustomConcession =
        response?.latestConcessionDetailsDTOList?.find(
          (item) => item?.concessionType === "CUSTOM"
        );

      if (latestCustomConcession) {
        showModal({
          title: "Approval Percentages",
          content: <ApprovalList data={latestCustomConcession} />,
        });
      } else {
        failureToast("No CUSTOM concession data found.");
      }
    } catch (error) {
      failureToast("Failed to fetch approval breakdown.");
    }
    setLoading(false);
  };

  return (
    <div className={`${classNameList} cursor-pointer`}>
      <AiOutlineInfoCircle
        color="#00B0F5"
        size={16}
        onClick={handleOpenModal}
        style={{ cursor: "pointer" }}
      />
    </div>
  );
};

export default ViewApprovalPercentageBreakdown;
